import { z } from 'zod';
import { periodoInput } from './common';

export const resumoFinanceiroInput = periodoInput.extend({
  campanhaId: z.string().uuid().optional(),
});

export const resumoFinanceiroOutput = z.object({
  totalReceitas: z.number(),
  totalDespesas: z.number(),
  saldo: z.number(),
  receitasPendentes: z.number(),
  despesasPendentes: z.number(),
  contasPorStatus: z.object({
    pendentes: z.number(),
    pagas: z.number(),
    vencidas: z.number(),
    canceladas: z.number(),
  }),
});

export const vendasHojeOutput = z.object({
  totalVendas: z.number(),
  quantidadeVendas: z.number(),
  ticketMedio: z.number(),
  vendasPorFormaPagamento: z.array(
    z.object({
      formaPagamento: z.string(),
      total: z.number(),
      quantidade: z.number(),
    })
  ),
});

export const estoqueBaixoOutput = z.object({
  produtos: z.array(
    z.object({
      id: z.string(),
      nome: z.string(),
      quantidadeEstoque: z.number(),
    })
  ),
  total: z.number(),
});

export type ResumoFinanceiroInput = z.infer<typeof resumoFinanceiroInput>;
export type ResumoFinanceiroOutput = z.infer<typeof resumoFinanceiroOutput>;
export type VendasHojeOutput = z.infer<typeof vendasHojeOutput>;
export type EstoqueBaixoOutput = z.infer<typeof estoqueBaixoOutput>;
